import getCaptionForElement from '../../common/helpers/get-caption-for-element';
import getLabelTriggerWidth from '../../control-pane/helpers/get-label-trigger-width';

function getDragTriggerContainerLabeledProps(targetElement, isLayerSelectShown = false) {
  const glyphSize = 24;

  const { label } = getCaptionForElement(targetElement);

  const triggerTotalWidth = getLabelTriggerWidth(label, true, isLayerSelectShown) + glyphSize;

  return {
    glyph: 'drag',
    glyphSize,
    width: triggerTotalWidth,
    label,
  };
}

export default getDragTriggerContainerLabeledProps;
